/**
 * `blue-800`. The brand `blue-500` (#00A4FF) is 2.71:1 against white and
 * 2.5–2.7:1 as text on cream — both below WCAG AA's 4.5:1. Every directory
 * surface uses the darker shade for text, solid CTAs and focus rings; tints
 * and hairlines keep blue-500 so the surfaces still read as SpotMe.
 *
 * Shared by the reveal and the claim flow so the two panels on the same ficha
 * cannot drift apart. Measured table: docs/claude/design-language.md.
 */
export const ACCESSIBLE_BLUE = '#005E92'

/**
 * Error text on the directory surfaces.
 *
 * The palette's own `red-800` (#EE5568) is its DARKEST red — 700/600/500 are
 * the same value or lighter — and it measures **3.18:1 on cream-300** and
 * 3.37:1 on cream-100, so every error message rendered in it fails AA. There
 * is no darker token to reach for, which is why this is a constant here rather
 * than a class: same shape as `ACCESSIBLE_BLUE` above, same reason.
 *
 * #B3182B measures 6.32:1 on cream-300, 6.70:1 on cream-100 and 6.81:1 on
 * white. If a proper dark-red token is ever added to `tailwind.config.js`, this
 * constant is the one place to retire.
 */
export const ACCESSIBLE_RED = '#B3182B'

/**
 * MUI's `ButtonBase` sets `outline: 0`, and its `outlined` variant defines no
 * `.Mui-focusVisible` style at all — so a `<BaseButton>` has NO visible focus
 * indicator unless the call site adds one. (The `contained` variant substitutes
 * a soft drop shadow, which is neither a contrasting ring nor allowed by the
 * design language.) Every `BaseButton` in the directory flow spreads this.
 */
export const FOCUS_RING =
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink-700'
